import { cancerTypes } from '../../../util/data/cancerTypes';
import { indications } from '../../../util/data/indications';

let cancerTypeOrder = [2,3,5,9,23,10,15,16,24,11,12,17,22,8,4,21,7,19, 25];

export const getCancerTypeIdFromIndicationId = (indicationID) => {
    let cancerType = Object.values(cancerTypes).find(cancerType => cancerType.indications.includes(indicationID));
    return cancerType.id;
}

export const createIndicationListEntryByCancerType = (cancerTypeId) => {
    let items = cancerTypes[cancerTypeId].indications.map(
        indicationID => indications[indicationID]
    );

    return {
        id: cancerTypeId,
        modifierAndName: `${cancerTypes[cancerTypeId].modifier} ${cancerTypes[cancerTypeId].name}`,
        items: items,
        indicationIds: cancerTypes[cancerTypeId].indications //used for filtering
    };
}



//when we launched, the IndicationPreviewDrawer was set to always be global. The TNBC 522 launch meant we had to create a filtered version of every aspect of the Safety/Indications, so this is a hacky workaround done in a few hours. Can probably be wholly rethought.
export const createIndicationPreviewText = (indicationId) => {

    let flatIndicationList = [];

    let cancerTypeList = (indicationId) ? [getCancerTypeIdFromIndicationId(indicationId)] : cancerTypeOrder;
    //create an ordered, flat list of JUST indication statements, without the cancer type groups:
    cancerTypeList.map(cancerTypeId => {
        cancerTypes[cancerTypeId].indications.map(
            indicationID => flatIndicationList.push(indications[indicationID].qlexIndicationStatement.replace(/<[^>]*>?/gm, ''))
        )}
    );

    return flatIndicationList.slice(0,2).join('<br/>');
}

// export const createSubQIndicationPreviewText = (indicationId) => {
//     let flatIndicationList = [];

//     const getCancerTypeIdFromSubQIndicationId = (indicationID) => {
//         return Object.values(cancerTypes).find(cancerType =>
//             cancerType.subQIndications?.includes(indicationID))?.id;
//     };

//     let cancerTypeList = (indicationId)
//         ? [getCancerTypeIdFromSubQIndicationId(indicationId)]
//         : cancerTypeOrder;

//     // Flatten subQ indications and strip HTML
//     cancerTypeList.forEach(cancerTypeId => {
//         const subQIndicationIds = cancerTypes[cancerTypeId]?.subQIndications || [];
//         subQIndicationIds.forEach(id => {
//             if (subQIndications[id]) {
//                 flatIndicationList.push(
//                     subQIndications[id].statement.replace(/<[^>]*>?/gm, '')
//                 );
//             }
//         });
//     });

//     return flatIndicationList.slice(0, 2).join('');
// }; 

// export const createSubQIndicationListEntryByCancerType = (cancerTypeId) => {
//     const subQIndicationsList = cancerTypes[cancerTypeId]?.subQIndications;

//     if (!subQIndicationsList || subQIndicationsList.length === 0) {
//       return null;
//     }
  
//     const items = subQIndicationsList.map(id => subQIndications[id]);

//     return {
//         id: cancerTypeId,
//         modifierAndName: cancerTypes[cancerTypeId].subQIndicationHeading ? cancerTypes[cancerTypeId].subQIndicationHeading : `${cancerTypes[cancerTypeId].modifier} ${cancerTypes[cancerTypeId].name}`,
//         items: items,
//         indicationIds: cancerTypes[cancerTypeId].subQIndications //used for filtering
//     };
// }

export const indicationsData = cancerTypeOrder.map(cancerTypeId => createIndicationListEntryByCancerType(cancerTypeId));


export { default as globalSafety } from './globalSafety';